import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  User,
} from "firebase/auth";
import React, { useState } from "react";
import { UserContext } from "./user-context";

export const UserContextProvider: React.FC = ({ children }) => {
  const [user, setUser] = useState<User>();
  const auth = getAuth();

  const logIn = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider).then((result) => {
      setUser(result.user);
    });
  };

  const logOut = () => {
    signOut(auth);
  };

  return (
    <UserContext.Provider value={{ logIn, user, logOut }}>
      {children}
    </UserContext.Provider>
  );
};
